const VineMass=[
    //{
        //id:1,
        //title:"Echo Fals «White Zinfadel» (США) рожеве/напівсух. 0,75л",
        //price:"555 грн",
        //src: require('../img/echozin.webp'),
        //text:"100мл - 74грн",
   // },
    {
        id:2,
        title:"Sensi «Collezione Pinot Grigio» (Італія) біл./сух. 0,75л",
        price:"825 грн",
        src: require('../img/sensipino.png'),
        text:"100мл - 110 грн",
    },
    {
        id:3,
        title:"Sensi Chianti «Dalcampo» (Італія) черв./сух. 0,75л",
        price:"825 грн",
        src: require('../img/sensidal.webp'),
        text:"100мл - 110 грн",
    },
    // {
    //     id:4,
    //     title:"Baron Simon (Іспанія) біл./напівсол. 0,75л",
    //     price:"450 грн",
    //     src: require('../img/baronSimonBel.png'),
    //     text:"100мл - 60грн",
    // },
    // {
    //     id:5,
    //     title:"Castillo San Simon (Іспанія) черв./сух. 0,75л",
    //     price:"450 грн",
    //     src: require('../img/sanSimonKrasn.png'),
    //     text:"100мл - 60грн",
    // },
    // {
    //     id:6,
    //     title:"Castillo San Simon (Іспанія) біл./сух. 0,75л",
    //     price:"450 грн",
    //     src: require('../img/sanSimonBel.png'),
    //     text:"100мл - 60грн",
    // },
    // {
    //     id:7,
    //     title:"Terra Italianica «Bianco» (Італія) біл./напівсол. 0,75л",
    //     price:"450 грн",
    //     src: require('../img/terrab.webp'),
    //     text:"100мл - 60грн",
    // },
    // {
    //     id:8,
    //     title:"Terra Italianica «Rosso Amabile» (Італія) черв./напівсол. 0,75л",
    //     price:"450 грн",
    //     src: require('../img/terrar.webp'),
    //     text:"100мл - 60грн",
    // },
    // {
    //     id:9,
    //     title:"Geo «Alazani Valley» (Грузія) черв./напівсол. 0,75л",
    //     price:"450 грн",
    //     src: require('../img/geovaleykr.png'),
    //     text:"100мл - 60грн",
    // },
    // {
    //     id:10,
    //     title:"Geo «Alazani Valley» (Грузія) біл./напівсол. 0,75л",
    //     price:"450 грн",
    //     src: require('../img/geovaleybel.png'),
    //     text:"100мл - 60грн",
    // },
    {
        id:11,
        title:"Don Simon «Sauvignon Blanc» (Іспанія) біл./сух. 0,75л",
        price:"560 грн",
        src: require('../img/donbel.png'),
        text:"100мл - 80 грн",
    },
    {
        id:12,
        title:"Don Simon «Cabernet Sauvignon» (Іспанія) черв./сух. 0,75л",
        price:"560 грн",
        src: require('../img/donkr.png'),
        text:"100мл - 80 грн",
    },
    {
        id:13,
        title:"Don Simon white semi-sweet (Іспанія) біл./напівсол. 0,75л",
        price:"560 грн",
        src: require('../img/whitedon.png'),
        text:"100мл - 80 грн",
    },
    {
        id:14,
        title:"Don Simon red semi-sweet (Іспанія) черв./напівсол. 0,75л",
        price:"560 грн",
        src: require('../img/reddon.png'),
        text:"100мл - 80 грн",
    },
]

export default VineMass;